<template>
  <div>
    <div slot="default" style="width: 100%">
      <div :class="title_component">
        <!-- possibility to replay only video with pointer_event:auto, default is "pointer_event:none" -->
        <video
          :style="`pointer-events: ${pointer_event}`"
          playsinline
          webkit-playsinline
          ref="myVideo"
          :class="`video-js irealviewer ${this.attributes.mode}`"
          data-setup="{}"
        ></video>
      </div>
      <div v-if="$store.getters.isStarted && this.config.attributes.text">
        <Message
          class="h5 m-1"
          :msg="`${this.config.attributes.text}`"
        ></Message>
      </div>
    </div>

    <ruler-widget
      v-if="config.attributes.ruler"
      :sceneWidth="12"
      :sceneHeight="12"
      :refunity="unity"
    ></ruler-widget>

    <snapshot-widget v-if="config.attributes.snapshot"></snapshot-widget>

    <span
      v-for="(interaction_widget, i) in definitions"
      @click="OpenLink(interaction_widget.attributes.flux, i, config.elements)"
      :class="interaction_widget.attributes.flux"
      :key="interaction_widget.attributes.flux"
    >
      <span v-if="interaction_widget.name === 'interaction'">
        <interaction-widget
          :class="$store.state.player.isStarted ? '' : 'd-none'"
          :position="interaction_widget.attributes.position"
          :flux="interaction_widget.attributes.flux"
        ></interaction-widget>
      </span>
    </span>
  </div>
</template>
<script src="/node_modules/videojs-vimeo-v2/src/Vimeo.js"></script>

<script>
import dataComponentMixin from "ireal-vue/mixins/data-component-mixin.js";
import videojs from "video.js";
import Bus from "../services/bus.js";
import CollapsibleWidget from "ireal-vue/widgets/CollapsibleWidget.vue";
import RulerWidget from "ireal-vue/widgets/RulerWidget.vue";
import Message from "ireal-vue/components/MessageComponent.vue";
import InteractionWidget from "ireal-vue/widgets/InteractionWidget.vue";
import SnapshotWidget from "ireal-vue/widgets/SnapshotWidget.vue";

export default {
  name: "video-component",
  mixins: [dataComponentMixin],
  components: {
    CollapsibleWidget,
    RulerWidget,
    Message,
    InteractionWidget,
    SnapshotWidget,
  },
  data() {
    return {
      // VideoJS player
      player: null,
      // URL of the video
      source: "",
      pausetime: 0,
      laggtime: 0,
      datatime: "",
      poster: "",
      currentime: 0,
      navigateur: navigator.platform,
      stepVideo: null,
      unity: "cm",
      list_interaction: [],
    };
  },
  async created() {
    this.definitions = this.config.elements;
  },
  async mounted() {
    // on utilise "ref" au lieu de "id" afin d'éviter les conflits d'id unique alors que l'on va générer différentes videos ( principe vu dans la doc)
    // ressource: https://docs.videojs.com/tutorial-vue.html
    // Initialize playerc
    if (this.config.attributes.ruler) {
      setTimeout(() => {
        var resizeEvent = window.document.createEvent("UIEvents");
        resizeEvent.initUIEvent("resize", true, false, window, 0);
        window.dispatchEvent(resizeEvent), 2000;
      });
    }
    this.player = videojs(this.$refs.myVideo, {
      controls: true,
      fluid: true,
    });
    // Sets initial poster
    this.setPoster();
    // Configure player source
    this.attributes.aspectRatio
      ? this.player.aspectRatio(this.attributes.aspectRatio)
      : this.player.aspectRatio("16:9");

    // Change poster on value changes
    Bus.$on("value-changed", async (payload) => {
      if (payload.param == this.model_poster) {
        this.setPoster(payload.value);
      }
    });
    // catch the program "ireal-start" ( send by the mutation store )
    Bus.$on("ireal-start", async () => {
      this.source = await this.getObservationVideo();
      this.$store.commit("test", this.source.parameters);
      this.writeTimeStart(this.source.start * 1000);

      if (this.source == undefined) {
        alert("no experience matches your criteria. Check your settings");
        this.$store.commit("stopPlayer");
      }

      this.datatime = {
        duration: this.source.duration,
        start: this.source.start,
        end: this.source.start + this.source.duration,
      };
      if (this.source === undefined) {
        console.log("Erreur lors de la récupération du flux video");
        return;
      }
      // Configure player source
      this.attributes.aspectRatio
        ? this.player.aspectRatio(this.attributes.aspectRatio)
        : this.player.aspectRatio("16:9");
      this.player.src({
        // for vimeo , example: Video.src="https://player.vimeo.com/external/215988962.hd.mp4?s=7675f70ba2fd93ed4007e1cdbb38ff1c53367145&profile_id=119"
        // source: https://forum.alsacreations.com/topic-5-81086-1-Plusieurs-videos-dans-un-meme-lecteur.html
        // dans vimeo: vidéos / liens de fichier vidéo/copier le lien du fichier mp4
        // exemple fichier ireal: https://player.vimeo.com/external/374110197.sd.mp4?s=94dc935887ddd19b3e918da6ea968c1f2d8825d0&profile_id=165
        type: "video/mp4",
        src: this.source.video_path_hd,
      });

      // Compute time when the video must pause
      // this.source.duration === -1 for failure video
      this.pausetime =
        this.source.duration !== -1
          ? this.datatime.duration + this.datatime.start
          : this.player.duration();

      // Play video
      this.player.play();
      // Position video cursor
      // WARNING: condition 'loadedmetadata' is very important because otherwise the start time is not respected on safari
      // without 'loadedmetadata': the video launches since the beginning of the rush, on safari
      this.player.on("loadedmetadata", () => {
        this.$store.commit("playPlayer");
        this.player.currentTime(this.datatime.start);
        // TODO: trouver une meilleure astuce de positionnement du current time pour IOS
        // ici, on attends un moment pour faire un forward car avec cette action, le current time est bien pris en compte ...
        if (navigator.platform.includes("iPhone")) {
          setTimeout(() => {
            this.$store.commit("forwardPlayer", 1000);
            this.$store.commit("backPlayer", 1000);
          }, 100);
        }
      });
      // reaction if an interaction widget is clicking. The videoComponent dependant change his source of video
      if (this.attributes.interaction_dependance) {
        Bus.$on("change-src-video", async (payload) => {
          this.source = await this.getNewObservationVideo(payload);
          this.player.src({
            type: "video/mp4",
            src: this.source.video_path_sd,
          });
          this.setPoster(null);
          this.datatime.start = Math.ceil(this.$store.getters.progress / 1000);
          this.player.on("loadedmetadata", () => {
            Bus.$emit("ireal-resync", this.$store.getters.progress / 1000);
            this.player.play();

            // TO DO SYNCHRO
          });

          //TODO: éliminer le décalage de synchronisation au changement de la video en interaction avec la video principale
        });
      }
      // Set experiment duration based on video duration
      this.$store.commit("setDuration", this.datatime.duration * 1000);
      console.log(" video is loaded");
      this.$store.commit("lagging", { uuid: this.uuid, value: false });
    });

    Bus.$on("ireal-tick", async () => {
      if (!this.player.paused() && this.$store.getters.finish < 1) {
        //TODO: perf le store est mis à jour trop régulièrement. il faut commiter le store que quand la valeur du lagging change.

        this.player.readyState() == 4
          ? this.$store.commit("lagging", { uuid: this.uuid, value: false })
          : this.$store.commit("lagging", { uuid: this.uuid, value: true });

        this.currentime = this.player.currentTime();
      }
      if (
        this.player.readyState() == 4 &&
        this.$store.getters.lagging &&
        this.$store.getters.isPlaying &&
        this.$store.getters.finish < 1
      ) {
        this.$store.commit("laggingtime", this.player.currentTime());
        this.player.pause();
      }
      if (
        this.player.paused() &&
        !this.$store.getters.lagging &&
        this.$store.getters.isPlaying &&
        this.$store.getters.finish < 1
      ) {
        this.player.play();
        this.player.currentTime(
          this.datatime.start + this.$store.getters.progress / 1000
        );
      }

      if (this.player.currentTime() > this.pausetime) {
        this.player.pause();
      }
    });

    Bus.$on("ireal-stop", async () => {
      this.player.reset();
      window.setTimeout(() => this.player.poster(this.poster), 1);
      // voir aussi Vue.nextTick( [callback, context] ) au lieu de setTimeout()
    });

    Bus.$on("ireal-pause", async () => {
      //var myPlayer = videojs(this.$refs.myVideo);
      this.player.pause();
    });
    Bus.$on("ireal-un-pause", async () => {
      //var myPlayer = videojs(this.$refs.myVideo);
      this.player.play();
    });
    Bus.$on("ireal-speed", async (speed) => {
      //var myPlayer = videojs(this.$refs.myVideo);
      this.player.playbackRate(speed);
    });
    Bus.$on("ireal-endpoint", async (time) => {
      this.player.currentTime(time / 1000);
      this.player.play();
    });
    Bus.$on("ireal-resync", async (progress) => {
      //var myPlayer = videojs(this.$refs.myVideo);
      var time = Math.ceil(this.datatime.start + progress / 1000);
      if (time < this.datatime.start) time = this.datatime.start;
      if (time > this.datatime.end) {
        time = this.datatime.end;
        this.player.currentTime(time);
      } else {
        this.player.currentTime(time);
        this.player.play();
      }
    });
  },
  methods: {
    prepare() {},
    setPoster(value) {
      value = value ? `_${value}` : "";
      this.poster = `${this.IREALCONFIG.static_ressources}/labs/${this.$store.getters.experienceIdentifier}/${this.$store.getters.experienceIdentifier}_${this.flux_identifier}${value}_poster.jpg`;
      this.player.poster(this.poster);
    },

    OpenLink(event, i, c) {
      this.$store.commit("changeSrcVideo", event);
    },
  },
};
</script>
<style scoped>
.portrait {
  min-height: 50vh !important;
}
</style>
<style src="video.js/dist/video-js.css"></style>
